"use strict";
var user_service_1 = require("./common/user/user.service");
var groups_service_1 = require("./common/groups/groups.service");
var institution_service_1 = require("./common/institution/institution-service");
var groups_init_service_1 = require("./groups/groups-init/groups-init.service");
var messaging_service_1 = require("./common/messaging/messaging.service");
var students_service_1 = require("./common/students/students.service");
var study_programs_service_1 = require("./common/study-programs/study-programs.service");
var navigation_menu_service_1 = require("./common/top-nav/navigation-menu.service");
var instructors_service_1 = require("./common/instructors/instructors.service");
var user_session_service_1 = require("./common/user-session/user-session.service");
var preference_service_1 = require("./common/preference/preference.service");
var layout_init_service_1 = require("./layout-init/layout-init.service");
var feature_service_1 = require("./common/feature/feature.service");
var typeahead_provider_service_1 = require("./common/typeahead-provider/typeahead-provider.service");
var cookie_monster_service_1 = require("./cookie-monster/cookie-monster.service");
var insights_popover_service_1 = require("./insights/insights-popover.service");
function initServices(app) {
    app.service("userService", user_service_1.userService);
    app.service("groupsService", groups_service_1.groupsService);
    app.service("studentsService", students_service_1.studentsService);
    app.service("institutionService", institution_service_1.institutionService);
    app.service("groupsInitService", groups_init_service_1.groupsInitService);
    app.service("messagingService", messaging_service_1.messagingService);
    app.service("studyProgramsService", study_programs_service_1.studyProgramsService);
    app.service("navigationMenuService", navigation_menu_service_1.navigationMenuService);
    app.service("instructorsService", instructors_service_1.instructorsService);
    app.service("userSessionService", user_session_service_1.UserSessionService);
    app.service("preferenceService", preference_service_1.preferenceService);
    app.service("layoutInitService", layout_init_service_1.layoutInitService);
    app.service("featureService", feature_service_1.featureService);
    app.service("typeaheadProviderService", typeahead_provider_service_1.TypeaheadProviderService);
    app.service("cookieMonsterService", cookie_monster_service_1.CookieMonsterService);
    app.service("insightsPopoverService", insights_popover_service_1.InsightsPopoverService);
}
exports.initServices = initServices;



/** WEBPACK FOOTER **
 ** ./app/app.services.ts
 **/